import * as userActions from 'redux/actions/user.actions'
import * as usageActions from 'redux/actions/appUsage.actions'

const initialState = {
  domains: {
    limit: 0,
    used: 0
  },
  keywords: {
    limit: 0,
    used: 0
  },
  competitors: {
    limit: 0,
    used: 0
  },
  keywordFinder: {
    limit: 0,
    used: 0
  },
  backlinkChecker: {
    limit: 0,
    used: 0
  },
  serpChecker: {
    limit: 0,
    used: 0
  },
  difficulty: {
    limit: 0,
    used: 0
  }
}

const appUsageReducer = (state = initialState, { type, payload = {} }) => {
  const qty = !isNaN(payload.qty) ? parseInt(payload.qty) : 0 
  switch (type) {
    case usageActions.setUsage.type: {
      const usage = payload.data?.data?.attributes?.usage
      return {
        ...state,
        // keywordFinder: { used: 84, limit: 100 },
        // serpChecker: { used: 84, limit: 100 }
        domains: usage?.domains,
        difficulty: usage?.keywordDifficulty,
        keywords: usage?.keywords,
        competitors: usage?.competitors,
        keywordFinder: usage?.keywordFinder,
        serpChecker: usage?.serpChecker,
        backlinkChecker: usage?.backlinkChecker
      }
    }
    case usageActions.hitKeywords.type: {
      const used = parseInt(state.keywrods.used) + qty
      return {
        ...state,
        keywords: {
          ...state.keywords,
          used
        }
      }
    }
    case usageActions.hitCompetitors.type: {
      const used = parseInt(state.competitors.used) + qty
      return {
        ...state,
        competitors: {
          ...state.competitors,
          used
        }
      }
    }
    case usageActions.hitKeywordFinder.type: {
      const used = parseInt(state.keywordFinder.used) + qty
      return {
        ...state,
        keywordFinder: {
          ...state.keywordFinder,
          used
        }
      }
    }
    case usageActions.hitBacklinkChecker.type: {
      const used = parseInt(state.backlinkChecker.used) + qty
      return {
        ...state,
        backlinkChecker: {
          ...state.backlinkChecker,
          used
        }
      }
    }
    case usageActions.hitSerpChecker.type: {
      const used = parseInt(state.serpChecker.used) + qty
      return {
        ...state,
        serpChecker: {
          ...state.serpChecker,
          used
        }
      }
    }
    case userActions.logout.type:
      return initialState
    default:
      return state
  }
}
export default appUsageReducer
